<div class="inbuilt-speedometer-v2" aria-label="Inbuilt speedometer">
  <div class="speedometer-chart" #speedometerContainer></div>

  <div class="value-stack mt-2">
    <!-- <p class="value-title">Current Value</p> -->
    <p class="current-value">{{ formatValue(currentValue) }}</p>
    <p class="current-percentage">{{ currentPercentage | number:'1.1-2' }}%</p>
  </div>

  <!-- <div class="range-list" aria-label="Speedometer ranges">
    <div class="range-item" *ngFor="let segment of segments">
      <span class="range-color" [style.background-color]="segment.color"></span>
      <span class="range-value">{{ formatCompact(segment.from) }} - {{ formatCompact(segment.to) }}</span>
    </div>
  </div> -->
</div>
